import _debounce from 'lodash/debounce';
import { useCallback, useEffect, useState } from 'react';
import config from '../app/config';

export default function useDebounce(event, delay = config.DEBOUNCE_DELAY) {
  const [debouncedEvent, setDebouncedEvent] = useState();
  useEffect(() => {
    setDebouncedEvent(() => _debounce(event, delay));
  }, []);

  return useCallback(debouncedEvent, [debouncedEvent]);
}
